
import React from 'react';
import { Flower } from 'lucide-react';

const BrandLogo: React.FC = () => {
  return (
    <div className="flex items-center">
      <a 
        href="/" 
        className="relative flex items-center gap-2 px-6 py-2 rounded-xl font-bold text-2xl md:text-3xl
          bg-transparent border border-purple-soft
          shadow-[0_0_15px_rgba(139,92,246,0.3)]
          transition-all duration-300
          group
          hover:shadow-[0_0_25px_rgba(139,92,246,0.5)]
          hover:border-purple-light"
      >
        <span className="relative">
          <span className="bg-gradient-to-r from-purple-200 to-pink-200 bg-clip-text text-transparent
            transition-all duration-300 group-hover:from-purple-100 group-hover:to-pink-100">
            We Trippy
          </span>
          <span className="absolute -bottom-1 left-0 w-full h-0.5 
            bg-gradient-to-r from-purple-400/50 to-pink-400/50
            transform scale-x-0 group-hover:scale-x-100 
            transition-transform duration-300 origin-left"></span>
        </span>
        <span className="relative flex items-center">
          <Flower 
            className="w-6 h-6 md:w-8 md:h-8 
              text-purple-300 transition-all duration-300
              group-hover:text-purple-200
              group-hover:rotate-12" 
          />
        </span>
      </a>
    </div>
  );
};

export default BrandLogo;
